import { ChangeEvent } from 'react';
import { Box, Typography, FormControlLabel, Checkbox } from '@mui/material';
import SmsLockScreen from './creation/sms/SmsLockScreen';
import SmsCounter from './creation/sms/SmsCounter';

interface SmsPhoneMockupProps {
  message: string;
  enrichi: boolean;
  onMessageChange: (value: string) => void;
  onEnrichiChange: (value: boolean) => void;
}

function SmsPhoneMockup({ message, enrichi, onMessageChange, onEnrichiChange }: SmsPhoneMockupProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        gap: { xs: 3, md: 5 },
      }}
    >
      <SmsLockScreen message={message} />

      <Box sx={{ width: '100%', maxWidth: 460, flex: { md: 1 } }}>
        <SmsCounter charCount={message.length} />

        <Box
          component="textarea"
          value={message}
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => onMessageChange(e.target.value)}
          placeholder="Ecrivez votre message ici..."
          sx={{
            width: '100%',
            minHeight: { xs: 110, md: 220 },
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            outline: 'none',
            resize: 'none',
            p: 1.5,
            fontSize: '0.83rem',
            fontFamily: 'inherit',
            color: 'grey.900',
            backgroundColor: 'background.paper',
            lineHeight: 1.6,
            boxSizing: 'border-box',
            '&::placeholder': { color: 'text.disabled' },
            '&:focus': { borderColor: 'primary.main' },
          }}
        />

        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={enrichi}
                onChange={e => onEnrichiChange(e.target.checked)}
                sx={{ py: 0.25, '&.Mui-checked': { color: 'primary.main' } }}
              />
            }
            label={
              <Typography variant="caption" sx={{ fontSize: '0.73rem', color: 'text.primary' }}>
                SMS <strong>enrichi</strong>
              </Typography>
            }
            sx={{ mx: 0 }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default SmsPhoneMockup;
